// extracted by mini-css-extract-plugin
export var playButton = "VimeoVideo-module--playButton--UXdtD";
export var poster = "VimeoVideo-module--poster--D5KoV";
export var text = "VimeoVideo-module--text--XNzh7";
export var videoWrapper = "VimeoVideo-module--videoWrapper--0y8MN";